import { LanguageService, PageService, PageLoaderService, NotificationService, onLine$, AppLanguage, useDefaultDateLocale } from '@aston/foundation';
import { AppBaseComponent, LoaderSpinnerComponent, NotificationMessageComponent } from '@aston/foundation/components';
import { ActivatedRoute, Router, NavigationStart, RouterOutlet } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { defineLocale, enGbLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { frLocale, IPageAnchor } from '@aston/foundation';
import { filter, take, switchMap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { timer } from 'rxjs';

import { AppStoreActions, AppStoreSelectors } from './root-store/app-store';
import { AppConstants } from './app.constants';


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	providers: [
		TranslatePipe
	],
	imports: [RouterOutlet, LoaderSpinnerComponent, NotificationMessageComponent, AsyncPipe]
})
export class AppComponent extends AppBaseComponent implements OnInit {
	translatePipe = inject(TranslatePipe);
	private bsLocaleService = inject(BsLocaleService);
	modal = inject(NgbModal);
	private store = inject(Store);

	pageAnchors: IPageAnchor[] = [];

	appIsReady$ = this.store.select(AppStoreSelectors.selectIsReady);
	bootstrapError$ = this.store.select(AppStoreSelectors.selectBootstrapError);

	onLine$ = onLine$;

	constructor() {
		const translateService = inject(TranslateService);
		const languageService = inject(LanguageService);
		const pageService = inject(PageService);
		const notificationService = inject(NotificationService);
		const pageLoaderService = inject(PageLoaderService);
		const route = inject(ActivatedRoute);
		const router = inject(Router);

		super(translateService, languageService, pageService, notificationService, pageLoaderService, route, router);

		defineLocale(AppLanguage.FR, frLocale);
		defineLocale(AppLanguage.EN, enGbLocale);

		languageService.language$.subscribe(current => {
			this.bsLocaleService.use(current);
			useDefaultDateLocale(current)
		});

		pageService.pageAnchors$.subscribe(anchors => {
			this.pageAnchors = anchors;
		});

		router.events.pipe(
			filter(event => event instanceof NavigationStart),
			filter(_ => this.modal.hasOpenModals())
		).subscribe(_ => {
			alert(this.translatePipe.transform('App.NavigationMessage'));
			this.modal.dismissAll();
		});

		translateService.get('Filters.DateExpression')
							 .pipe(take(1))
							 .subscribe(keys => {
								 AppConstants.updateDateExpressionWithTranslation(keys);
							 });
	}

	ngOnInit() {
		super.ngOnInit();

		timer(0, AppConstants.SECOND)
			.pipe(
				switchMap(_ => this.store.select(AppStoreSelectors.selectIsInactive)),
				filter(isInactive => !isInactive)
			)
			.subscribe(_ => {
				this.store.dispatch(AppStoreActions.UpdateInactivityTimer());
			});
	}
}
